module.exports = __webpack_public_path__ + "static/media/Data_INTERNET_OF_THING_E_SENSORIZACAO.f6f3e020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/InternetOfThings/Data_INTERNET_OF_THING_E_SENSORIZACAO.png
// module id = 63
// module chunks = 0